<template>
   <el-tabs class='parameter-tabs' type="border-card">
      <el-tab-pane
         v-for="(item, index) in batParams"
         :key="index"
         :label="item.title">
         <parameters :params="item.params"/>
      </el-tab-pane>
   </el-tabs>
</template>

<script>
import { Tabs, TabPane } from 'element-ui';
import Parameters from '../Parameters';
import { formatCurrency,formatNumberNepaliStyle as formatNumber } from '../../../../../js/ui-helpers';
import { mapGetters } from 'vuex';

const getVariableInfos = (results, costs, {solar=false}={}) =>
{
    const hrs_per_day_label = solar ? "Peak Sun Shine Hour per Day (PSH)" : "Service Hour per Day (SH)"; 
    const days_per_yr_label = solar ? "Annual Sun Shine Days per Year (ASD)" : "Service Days per Year (ASD)"; 
    return {
        title: "Variables",
        infos:  [
            { label: "No. of Households (HH)",      value: results.num_household },
            { label: "Demand per HH (DHH)",         value: `${results.per_hh_demand_W} W`     },
            { label: "Total Energy Demand (TED)",   value: `${results.total_demand_kW} kW`  },
            { label: hrs_per_day_label,             value: `${costs.hrs_per_day}` },
            { label: days_per_yr_label,             value: `${costs.days_per_year}` },
            { label: "Electricity Generation (EG)", value: `${formatNumber(costs.electricity_generation)} kWh` },
        ],
    };
};

const getEnergyCostsInfos = (results, costs, {grid=false}={}) =>
{
    let infos = [
        { label: "Capital Cost(CC)",                    value: formatCurrency(costs.capital_cost) },
        { label: "Operation And Maintenence Cost(OMC)", value: formatCurrency(costs.operation_maintenance_cost) },
        { label: "Discount Rate(DR)",                   value: formatCurrency(costs.discount_rate) },
    ];
    if (!grid)
    {
        infos = [
            { label: "District Selected",                   value: `${results.municipality.district}` },
            { label: "Energy Cost(EC)",                     value: `Average of Cost/W ${formatCurrency(costs.system_cost_per_watt)}` },
            { label: "System Cost (SC)",                    value: formatCurrency(costs.system_cost) },
            { label: "Installation Cost",                   value: formatCurrency(costs.installation_cost) },
            { label: "Transportation Cost(TC)",             value: formatCurrency(costs.transportation_cost) },
            ...infos
        ];
    }    
    return { title: "Energy Costs", infos };
};

const getSolarReplacementCostInfos = () =>
{
    return {
        title: 'Replacement Costs',
        infos: [
            { label: "Charge Controller", value: 0,},
            { label: "Battery", value: formatCurrency(28000),},
            { label: "Cable And Accessories", value: 0,},
        ],
    };
};

const getParams = (results, costs, {solar=false, grid=false}={}) =>
{
    const params = [
        getVariableInfos(results, costs, {solar}),
        getEnergyCostsInfos(results, costs, {grid}),
    ];
    if (solar) params.push(getSolarReplacementCostInfos(results, costs));
    return params;
};

export default {
   name: "ParametersTabs",
   components: {
      'el-tabs': Tabs,
      'el-tab-pane': TabPane,
      Parameters,
   },
   computed: {
      ...mapGetters(['getBatResults']),
      batParams()
      {
        const results = this.getBatResults;
        if (!results) return [];
        const params = [
            { title: "Solar Home System", params: getParams(results, results.energy_costs.shs, {solar: true}) },
            { title: "Grid Extension", params: getParams(results, results.energy_costs.grid, {grid: true}) },
            { title: "Solar Minigrid", params: getParams(results, results.energy_costs.solar_minigrid, {solar: true}) },
        ];
        if (results.is_in_terai) return params;
        return [...params, { title: "Micro Hydro Power", params: getParams(results, results.energy_costs.mhp), }];
      }
   },
}
</script>

<style lang="scss">
.parameter-tabs {
   > .el-tabs__header {
      .el-tabs__item {
         font-size: 0.95em;

         &.is-active,
         &:not(.is-disabled):hover {
            color: $primary-color;
         }
      }
   }
   > .el-tabs__content {
      padding: 0;
   }
}
</style>
